import React from 'react';
import * as S from './styles';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { JOB_DETAILS_UI } from '../TranslationValues';

const NAMESPACES = ['JOB_DETAILS_UI', 'STATUS_MONITORING'];

const JobDetailsTab = ({ batch, isDraft = false, t }) => {
  const batchTypeMap = {
    STANDARD: { key: 'STANDARD_LABEL', value: 'Standard' },
    ADVANCED: { key: 'ADVANCED_LABEL', value: 'Advanced' },
    HYBRID: { key: 'HYBRID_LABEL', value: 'Hybrid' },
  };

  const channelMap = {
    PRINT: { key: 'CHANNEL_DOCUMENT', value: 'Documents' },
    EMAIL: { key: 'CHANNEL_EMAIL', value: 'Email' },
    MESSAGES: { key: 'CHANNEL_MESSAGES', value: 'Messages' },
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div>
        <S.CardHeader>{isDraft ? t(JOB_DETAILS_UI.SAVED_DETAILS.key, JOB_DETAILS_UI.SAVED_DETAILS.value) : t(JOB_DETAILS_UI.BASIC_JOB_INFO.key, JOB_DETAILS_UI.BASIC_JOB_INFO.value)}</S.CardHeader>
        <S.DetailsGrid>
          {/* <S.DetailItem>
                        <S.DetailLabel>Batch Name</S.DetailLabel>
                        <S.DetailValue>{batch?.batchName}</S.DetailValue>
                    </S.DetailItem> */}
          {batch?.batchType && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.JOB_TYPE.key, JOB_DETAILS_UI.JOB_TYPE.value)}</S.DetailLabel>
              <S.DetailValue>
                {batchTypeMap[batch.batchType]
                  ? t(batchTypeMap[batch.batchType].key, batchTypeMap[batch.batchType].value)
                  : batch.batchType}
              </S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.channelType && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.DELIVERY_CHANNEL.key, JOB_DETAILS_UI.DELIVERY_CHANNEL.value)}</S.DetailLabel>
              <S.DetailValue>
                {channelMap[batch.channelType.toUpperCase()]
                  ? t(channelMap[batch.channelType.toUpperCase()].key, channelMap[batch.channelType.toUpperCase()].value)
                  : batch.channelType.toUpperCase()}
              </S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.createdTime && (
            <>
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.CREATED_DATE.key, JOB_DETAILS_UI.CREATED_DATE.value)}</S.DetailLabel>
                <S.DetailValue>{moment(batch.createdTime).format('Do MMM YYYY')}</S.DetailValue>
              </S.DetailItem>
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.CREATED_TIME.key, JOB_DETAILS_UI.CREATED_TIME.value)}</S.DetailLabel>
                <S.DetailValue>{moment(batch.createdTime).format('h:mm A')}</S.DetailValue>
              </S.DetailItem>
            </>
          )}
          {batch?.splitType && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.SPLIT_CRITERIA.key, JOB_DETAILS_UI.SPLIT_CRITERIA.value)}</S.DetailLabel>
              <S.DetailValue>{batch.splitType === 'address' ? t(JOB_DETAILS_UI.ADDRESS.key, JOB_DETAILS_UI.ADDRESS.value) : t(JOB_DETAILS_UI.PAGE_COUNT.key, JOB_DETAILS_UI.PAGE_COUNT.value)}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.envelopeType && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.ENVELOPE_TYPE.key, JOB_DETAILS_UI.ENVELOPE_TYPE.value)}</S.DetailLabel>
              <S.DetailValue>{batch.envelopeType}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.batchType === 'HYBRID' && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.STATIONARY_NAME.key, JOB_DETAILS_UI.STATIONARY_NAME.value)}</S.DetailLabel>
              <S.DetailValue>{batch?.stationaryName}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.insertName && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.INSERT_NAME.key, JOB_DETAILS_UI.INSERT_NAME.value)}</S.DetailLabel>
              <S.DetailValue>{batch.insertName}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.deliveryClass && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.DELIVERY_CLASS.key, JOB_DETAILS_UI.DELIVERY_CLASS.value)}</S.DetailLabel>
              <S.DetailValue>{batch.deliveryClass}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.batchType === 'HYBRID' && batch?.totalCount && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.LETTER_COUNT.key, JOB_DETAILS_UI.LETTER_COUNT.value)}</S.DetailLabel>
              <S.DetailValue>{batch.totalCount}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.dataFile && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.DATA_FILE.key, JOB_DETAILS_UI.DATA_FILE.value)}</S.DetailLabel>
              <S.DetailValue>{batch.dataFile}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.scheduleTime && (
            <>
              <S.CardHeader>{t(JOB_DETAILS_UI.SCHEDULE_CONFIGURATION.key, JOB_DETAILS_UI.SCHEDULE_CONFIGURATION.value)}</S.CardHeader>
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.SCHEDULE_CONFIGURATION.key, JOB_DETAILS_UI.SCHEDULE_CONFIGURATION.value)}</S.DetailLabel>
                <S.DetailValue>{moment(batch.scheduleTime).format('Do MMM YYYY')}</S.DetailValue>
              </S.DetailItem>
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.SCHEDULED_TIME.key, JOB_DETAILS_UI.SCHEDULED_TIME.value)}</S.DetailLabel>
                <S.DetailValue>{moment(batch.scheduleTime).format('h:mm A')}</S.DetailValue>
              </S.DetailItem>
            </>
          )}
        </S.DetailsGrid>
      </div>

      {/* Job Specific Details */}
      {batch?.jobDetails && (
        <div style={{ paddingTop: '1.5rem', borderTop: '1px solid #e5e7eb' }}>
          <h4
            style={{ fontSize: '1rem', fontWeight: 700, color: '#1f2937', marginBottom: '0.75rem' }}
          >
            {t(JOB_DETAILS_UI.ADDITIONAL_DETAILS.key, JOB_DETAILS_UI.ADDITIONAL_DETAILS.value)}
          </h4>
          <S.DetailsGrid>
            {batch?.jobDetails?.language && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.LANGUAGE.key, JOB_DETAILS_UI.LANGUAGE.value)}</S.DetailLabel>
                <S.DetailValue>{batch?.jobDetails?.language}</S.DetailValue>
              </S.DetailItem>
            )}
            {batch?.jobDetails?.formData && (
              <S.DetailItem fullWidth>
                <S.DetailLabel style={{ marginBottom: '0.5rem' }}>{t(JOB_DETAILS_UI.FORM_VARIABLES.key, JOB_DETAILS_UI.FORM_VARIABLES.value)}</S.DetailLabel>
                <S.FormVariables>
                  {Object.entries(batch?.jobDetails?.formData).map(([key, value]) => (
                    <S.VariableRow key={key}>
                      <S.VariableLabel>{key}:</S.VariableLabel>
                      <S.VariableValue>{value}</S.VariableValue>
                    </S.VariableRow>
                  ))}
                </S.FormVariables>
              </S.DetailItem>
            )}

            {/* Template Info */}
            {batch?.jobDetails?.selectedTemplate && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.TEMPLATE.key, JOB_DETAILS_UI.TEMPLATE.value)}</S.DetailLabel>
                <S.DetailValue>{batch?.jobDetails?.selectedTemplate}</S.DetailValue>
              </S.DetailItem>
            )}
            {batch?.jobDetails?.templateCategory && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.TEMPLATE_CATEGORY.key, JOB_DETAILS_UI.TEMPLATE_CATEGORY.value)}</S.DetailLabel>
                <S.DetailValue>{batch?.jobDetails?.templateCategory}</S.DetailValue>
              </S.DetailItem>
            )}

            {/* Data Upload Info */}
            {batch?.jobDetails?.uploadedFile && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.UPLOADED_FILE.key, JOB_DETAILS_UI.UPLOADED_FILE.value)}</S.DetailLabel>
                <S.DetailValue>{batch?.jobDetails?.uploadedFile}</S.DetailValue>
              </S.DetailItem>
            )}
            {batch?.jobDetails?.recordCount && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.RECORD_COUNT.key, JOB_DETAILS_UI.RECORD_COUNT.value)}</S.DetailLabel>
                <S.DetailValue>{batch?.jobDetails?.recordCount.toLocaleString()}</S.DetailValue>
              </S.DetailItem>
            )}
          </S.DetailsGrid>
        </div>
      )}

      {/* Schedule Details (Advanced Only) */}
      {batch?.jobType === 'ADVANCED' && batch?.jobDetails?.schedule && (
        <div style={{ paddingTop: '1.5rem', borderTop: '1px solid #e5e7eb' }}>
          <h4
            style={{ fontSize: '1rem', fontWeight: 700, color: '#1f2937', marginBottom: '0.75rem' }}
          >
            {t(JOB_DETAILS_UI.SCHEDULE_CONFIGURATION.key, JOB_DETAILS_UI.SCHEDULE_CONFIGURATION.value)}
          </h4>
          <S.DetailsGrid>
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.SCHEDULED_DATE.key, JOB_DETAILS_UI.SCHEDULED_DATE.value)}</S.DetailLabel>
              <S.DetailValue>{batch?.jobDetails?.schedule?.scheduledDate}</S.DetailValue>
            </S.DetailItem>
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.SCHEDULED_TIME.key, JOB_DETAILS_UI.SCHEDULED_TIME.value)}</S.DetailLabel>
              <S.DetailValue>{batch?.jobDetails?.schedule?.scheduledTime}</S.DetailValue>
            </S.DetailItem>
          </S.DetailsGrid>
        </div>
      )}
    </div>
  );
};

export default withTranslation(NAMESPACES)(JobDetailsTab);
